import { Heading } from 'ui/components/1-atoms/Heading/Heading';
import styles from './EmployeeList.module.scss';
import { useState } from 'react';
import { Button } from 'ui/components/1-atoms/Action/Button/Button';
import { Grid } from 'ui/components/4-habitats/Grid/Grid';
import { Container } from 'ui/components/4-habitats/Container/Container';
import { EmployeeCard, EmployeeCardProps } from 'ui/components/2-molecules/Card/EmployeeCard/EmployeeCard';
import { GridCell } from 'ui/components/4-habitats/Grid/GridCell';
import classNames from 'classnames';
import ColorOptions from 'helpers/types';

export interface EmployeeListProps {
	heading?: string;
	subHeading?: string;
	employees: EmployeeCardProps[];
	showMoreButton?: string;
	showMoreAmount?: number;
	bgColor?: ColorOptions;
}

export const EmployeeList: React.FC<EmployeeListProps> = ({ heading, subHeading, employees, showMoreButton, showMoreAmount, bgColor = 'white' }) => {
	showMoreAmount = (showMoreAmount || 3) === -1 ? employees?.length : showMoreAmount || 3;
	const [amountOfEmplooyesShown, setAmountOfEmplooyesShown] = useState<number>(
		employees?.length > showMoreAmount ? showMoreAmount : employees?.length,
	);

	return (
		<div className={classNames(styles.EmployeeList, styles[`u-color___${bgColor}`])}>
			<Container width="Standard">
				{heading && (
					<Heading className={styles.EmployeeList_heading} headingLevel="h2" style="md">
						{heading}
					</Heading>
				)}

				{subHeading && (
					<Heading className={styles.EmployeeList_subHeading} headingLevel="h3">
						{subHeading}
					</Heading>
				)}

				{employees && (
					<>
						<Grid wrap largeGutter className={styles.EmployeeList_grid}>
							{employees.slice(0, amountOfEmplooyesShown).map((employee) => (
								<GridCell mobileWidth="100" desktopWidth="33" key={employee.id}>
									<EmployeeCard {...employee} />
								</GridCell>
							))}
						</Grid>

						{amountOfEmplooyesShown !== employees.length && (
							<div className={styles.EmployeeList_showMoreButton}>
								<Button
									inheritsColor
									style="primary"
									onClick={() => {
										if (amountOfEmplooyesShown <= employees.length - showMoreAmount) {
											setAmountOfEmplooyesShown(amountOfEmplooyesShown + showMoreAmount);
										} else {
											const difference = employees.length - amountOfEmplooyesShown;
											setAmountOfEmplooyesShown(amountOfEmplooyesShown + difference);
										}
									}}
								>
									{showMoreButton}
								</Button>
							</div>
						)}
					</>
				)}
			</Container>
		</div>
	);
};
